import { render, staticRenderFns } from "./AvailabilityDateWidget.vue?vue&type=template&id=0c64687f&"
import script from "./AvailabilityDateWidget.vue?vue&type=script&lang=js&"
export * from "./AvailabilityDateWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\xampp\\htdocs\\DIA-funsporthandel\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c64687f')) {
      api.createRecord('0c64687f', component.options)
    } else {
      api.reload('0c64687f', component.options)
    }
    module.hot.accept("./AvailabilityDateWidget.vue?vue&type=template&id=0c64687f&", function () {
      api.rerender('0c64687f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/widgets/AvailabilityDateWidget.vue"
export default component.exports